import { MainBrowseFilter } from '../interfaces';

export const BROWSE_DEFAULT_FILTER_VALUE: MainBrowseFilter = {
  page: 1,
  size: 10,
};
